import React from 'react';
import { Tag, Typography } from 'antd';
import { userDisplayName } from '@/utils/userOptionHelpers';

const { Text } = Typography;
const roleLabels = { doctor: 'Bác sĩ', sales: 'Sales' };

export default function CommissionRelatedEmployees({ employees = [] }) {
    if (!employees.length) return <Text type="secondary">Chưa xác định</Text>;

    return <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {employees.map(employee => {
            const roleName = employee.role_label || roleLabels[employee.role_key] || employee.role_key;
            const label = userDisplayName({
                role_name: roleName,
                full_name: employee.employee_name || `Nhân sự #${employee.employee_id}`,
            });
            return <div key={`${employee.employee_id}-${employee.role_key || ''}`} style={{ marginRight: 4, marginBottom: 4 }}>
                {label}
            </div>;
        })}
    </div>;
}
